import { render } from "./ReferencesPage.vue?vue&type=template&id=2ed9fd0e&scoped=true"
import script from "./ReferencesPage.vue?vue&type=script&lang=js"
export * from "./ReferencesPage.vue?vue&type=script&lang=js"

import "./ReferencesPage.vue?vue&type=style&index=0&id=2ed9fd0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed9fd0e"]])

export default __exports__